/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { d as isTm$1, e as isTb$1, f as isAp$1, g as isCn$1, h as isAliYun$1, j as isFm$1, k as isRetail$1, l as isRetailtrader$1, m as isXiongan$1, n as isAwf$1, o as isKb$1, p as isAk$1, q as isLt$1, r as isNj$1, s as isElmc$1, t as isIhome$1, u as isTphome$1, v as isAliwork$1, w as isEt$1, x as isBk$1, y as isLx$1, z as isQn$1, A as isCunpartner$1, B as isWdkhema$1, C as isAh$1, D as isMro$1, E as isMicrosupply$1, F as getAliAppName, G as appName, H as getUA, I as isAndroid, J as isIOS, K as isWeb, L as isWindvane, c as isNebula, M as isFliggy, N as isDingTalk, O as isDingTalkPC, P as isWeex, Q as isQuickApp, R as isMiniDingTalk, S as isMiniAli, T as isMiniTt, U as isMiniWx, V as isMiniAp, W as isMiniTb, X as isMiniTm, Y as isMiniFm, Z as isMiniLx, _ as isWebTm, $ as isWebAliyun, a as isWebCn, a0 as isWebFm, a1 as isWebRetail, a2 as isWebXionganapp, a3 as isWebAfw, i as isWebAp, a4 as isWebKb, a5 as isWebRetailtrader, a6 as isWebXm, a7 as isWebAk, a8 as isWebAt, a9 as isWebLt, aa as isWebNj, b as isWebTb, ab as isWebElmc, ac as isWebIhome, ad as isWebTphome, ae as isWebAliwork, af as isWebBk, ag as isWebEt, ah as isWebLx, ai as isWebQn, aj as isWebYouku, ak as isWebWdkhema, al as isWebCunpartner, am as isWebDingTalk, an as isWebAh, ao as isWebAlipm, ap as isWebDingTalkPC, aq as isMini, ar as isMiniweb } from '../../index-f24a9ec1.js';
import { e as isBaiduSmartProgram, a as isKuaiShouMiniProgram } from '../../index-892d8eee.js';

// @ali/uni-env再加工。菜鸟扩展的env放到config中
// 方法转变量，调用者不迷惑：getXXX为方法，isXXX为变量
var isTm = isTm$1();
var isTb = isTb$1();
var isAp = isAp$1();
var isCn = isCn$1();
var isAliYun = isAliYun$1();
var isFm = isFm$1();
var isRetail = isRetail$1();
var isRetailtrader = isRetailtrader$1();
var isXiongan = isXiongan$1();
var isAwf = isAwf$1();
var isKb = isKb$1();
var isAk = isAk$1();
var isLt = isLt$1();
var isNj = isNj$1();
var isElmc = isElmc$1();
var isIhome = isIhome$1();
var isTphome = isTphome$1();
var isAliwork = isAliwork$1();
var isEt = isEt$1();
var isBk = isBk$1();
var isLx = isLx$1();
var isQn = isQn$1();
var isCunpartner = isCunpartner$1();
var isWdkhema = isWdkhema$1();
var isAh = isAh$1();
var isMro = isMro$1();
var isMicrosupply = isMicrosupply$1();

var uniEnv = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getAliAppName: getAliAppName,
    appName: appName,
    getUA: getUA,
    isAndroid: isAndroid,
    isIOS: isIOS,
    isWeb: isWeb,
    isWindvane: isWindvane,
    isNebula: isNebula,
    isFliggy: isFliggy,
    isDingTalk: isDingTalk,
    isDingTalkPC: isDingTalkPC,
    isWeex: isWeex,
    isQuickApp: isQuickApp,
    isMiniDingTalk: isMiniDingTalk,
    isMiniAli: isMiniAli,
    isMiniTt: isMiniTt,
    isMiniWx: isMiniWx,
    isMiniAp: isMiniAp,
    isMiniTb: isMiniTb,
    isMiniTm: isMiniTm,
    isMiniFm: isMiniFm,
    isMiniLx: isMiniLx,
    isTm: isTm,
    isTb: isTb,
    isAp: isAp,
    isCn: isCn,
    isAliYun: isAliYun,
    isFm: isFm,
    isRetail: isRetail,
    isRetailtrader: isRetailtrader,
    isXiongan: isXiongan,
    isAwf: isAwf,
    isKb: isKb,
    isAk: isAk,
    isLt: isLt,
    isNj: isNj,
    isElmc: isElmc,
    isIhome: isIhome,
    isTphome: isTphome,
    isAliwork: isAliwork,
    isEt: isEt,
    isBk: isBk,
    isLx: isLx,
    isQn: isQn,
    isCunpartner: isCunpartner,
    isWdkhema: isWdkhema,
    isAh: isAh,
    isMro: isMro,
    isMicrosupply: isMicrosupply,
    isWebTm: isWebTm,
    isWebAliyun: isWebAliyun,
    isWebCn: isWebCn,
    isWebFm: isWebFm,
    isWebRetail: isWebRetail,
    isWebXionganapp: isWebXionganapp,
    isWebAfw: isWebAfw,
    isWebAp: isWebAp,
    isWebKb: isWebKb,
    isWebRetailtrader: isWebRetailtrader,
    isWebXm: isWebXm,
    isWebAk: isWebAk,
    isWebAt: isWebAt,
    isWebLt: isWebLt,
    isWebNj: isWebNj,
    isWebTb: isWebTb,
    isWebElmc: isWebElmc,
    isWebIhome: isWebIhome,
    isWebTphome: isWebTphome,
    isWebAliwork: isWebAliwork,
    isWebBk: isWebBk,
    isWebEt: isWebEt,
    isWebLx: isWebLx,
    isWebQn: isWebQn,
    isWebYouku: isWebYouku,
    isWebWdkhema: isWebWdkhema,
    isWebCunpartner: isWebCunpartner,
    isWebDingTalk: isWebDingTalk,
    isWebAh: isWebAh,
    isWebAlipm: isWebAlipm,
    isWebDingTalkPC: isWebDingTalkPC
});

/**
 * ua 方便使用。
 * 1. web环境，ua=window.navigator.userAgent;
 * 2. mini环境，ua=window.navigator.swuserAgent;
 */
var ua = getUA();
/**
 * 1. App判断。（使用场景：web和小程序内都可用）
 */
var isWechat = ua.includes('MicroMessenger');
var isTbLive = appName === 'taobaoliveapp';
var isAli1688 = appName === '1688';
// 在Android端，唯一的ua叫cnstation；在Ios端，唯一的ua叫postoffice
var isCnStation = ['postoffice', 'cnstation'].includes(appName);
var isCnBgx = appName === 'bgx';
/**
 * 2. Mini小程序（使用场景：axml原生小程序或类tora小程序框架内用）
 */
// IDE（原则：先严格，再有新的再扩展）
var isMiniTbIDE = isMiniAli && ua.includes('Taobao') && ua.includes('AlipayIDE');
var isMiniApIDE = isMiniAli && ua.includes('AlipayClient') && ua.includes('AlipayIDE');
var isMiniDingTalkIDE = isMiniAli && ua.includes('DingTalkIDE') && ua.includes('AlipayIDE');
/**
 * 3. miniweb：小程序内嵌webview（使用场景：web中用）
 */
var isMiniwebDingTalk = isWeb && // TODO: isMiniweb有bug，暂时换为isWeb。需要多真机看下UA是否都是MiniProgram
    isDingTalk &&
    // 钉钉小程序web-view组件，ios端注入dd-web，需要特殊处理,所以ua判断使用MiniPrograme。https://yuque.antfin-inc.com/dingtalk-miniprogram/faq/cwva6h?view=
    ((isIOS && ua.indexOf('dd-web') > -1) || ua.indexOf('MiniProgram') > -1);
/**
 * 真机ua示例：
 * Mozilla/5.0 (iPhone; CPU iPhone os 16_3_1 like Mac OS X) AppleWebKit/605.1.15
 *  (KHTML, like Gecko) Mobile/15E148 MicroMessenger/8.0.32(0x18002035) NetType/WIFI
 *  Language/zh_CN miniProgram/wx795bd500b21f8fee
 */
var isMiniwebWechat = isMiniweb && isWechat;
var isMiniwebAli = isMiniweb && !isMiniwebWechat;
// 若官方 env(https://yuque.antfin-inc.com/multix/api/rgp412) 未实现 isWindvane,
// 则需扩展时进行补充, 补充格式: is + 环境首字母大写(如：Windvane)
/**
 * 扩展的env环境
 * 自定义环境变量，区分“包裹侠” & '驿站掌柜'等
 * isWeb: 只是判断是否在window环境中,而不管是在App内的浏览器还是App外的浏览器。主要是针对原生小程序这种没有window onload环境的情况做区别。
 *
 * 当前已识别的匹配关系：
 * tb 淘宝
 * tbLive 点淘(即淘宝直播独立App)
 * nubula 支付宝
 * cn 菜鸟
 * fm 闲鱼
 * cnStation 菜鸟驿站掌柜
 * browser 浏览器（无容器），比如电脑端的浏览器环境, 手机中原生 safari chrome 等。
 */
var extendEnv = {
    /**
     * 驿站掌柜App
     */
    isCnStation: isCnStation,
    /** 菜鸟包裹侠App */
    isCnBgx: isCnBgx,
    /** 1688 App */
    isAli1688: isAli1688,
    /** 点淘App，是淘宝直播团队新做的App,基于Windvane容器 */
    isTbLive: isTbLive,
    /** 微信App */
    isWechat: isWechat,
    /**
     * 纯浏览器，无任何容器
     * 除webview外的浏览器，比如电脑端的浏览器环境, 手机中原生 safari chrome 等
     */
    isBrowser: isWeb && !appName,
    /** 小程序环境。isMini支持了阿里系、微信、头条小程序、【新】百度小程序、快手小程序。【待支持】钉钉小程序 */
    isMini: isMini || isBaiduSmartProgram || isKuaiShouMiniProgram,
    /** 百度小程序 */
    isMiniBd: isBaiduSmartProgram,
    /** 快手小程序 */
    isMiniKs: isKuaiShouMiniProgram,
    /** 是否是小程序IDE环境。包含：O2 IDE、支付宝-小程序开发者工具IDE */
    isMiniIDE: isMiniTbIDE || isMiniApIDE || isMiniDingTalkIDE,
    /**
     * 是否淘宝的IDE - O2 环境
     * 请验证后使用，O2经常更新
     */
    isMiniTbIDE: isMiniTbIDE,
    // 扩展小程序内webview。
    /**
     * 小程序内嵌 Webview 环境。
     * isMiniweb支持了阿里小程序、微信小程序，【新】钉钉小程序
     */
    isMiniweb: isMiniweb || isMiniwebDingTalk,
    /**
     * 扩展钉钉小程序内嵌web-view。
     * by 钉钉jssdk源码：git@gitlab.alibaba-inc.com:dingding/dingtalk-jsapi.git
     */
    isMiniwebDingTalk: isMiniwebDingTalk,
    /** 微信小程序内嵌web-view */
    isMiniwebWechat: isMiniwebWechat,
    /** 阿里小程序内嵌web-view */
    isMiniwebAli: isMiniwebAli,
};

var Version = /** @class */ (function () {
    function Version(v) {
        this.val = v.toString();
        if (!this.val.match(/^([^.]+\.)*[^.]+$/) ||
            this.val.match(/^[^\d\w]|\.[^\d\w]|[^\d\w]$/i)) {
            console.error('invalid version');
        }
    }
    Version.compare = function (v1, v2) {
        var val1 = v1.toString().split('.');
        var val2 = v2.toString().split('.');
        for (var i = 0; i < val1.length || i < val2.length; i += 1) {
            var n1 = parseInt(val1[i], 10);
            var n2 = parseInt(val2[i], 10);
            if (Number.isNaN(n1)) {
                n1 = 0;
            }
            if (Number.isNaN(n2)) {
                n2 = 0;
            }
            if (n1 < n2) {
                return -1;
            }
            if (n1 > n2) {
                return 1;
            }
        }
        return 0;
    };
    /**
     * 当前app版本是否大于（>）传入的版本号
     *
     * @param  {string | number} v 传入的对比
     * @returns {boolean}
     */
    Version.prototype.gt = function (v) {
        return Version.compare(this.val, v) > 0;
    };
    /**
     * 当前app版本是否大于等于（>=）传入的版本号
     *
     * @param  {string | number} v 传入的对比
     * @returns {boolean}
     */
    Version.prototype.gte = function (v) {
        return Version.compare(this.val, v) >= 0;
    };
    /**
     * 当前app版本是否小于（<）传入的版本号
     *
     * @param  {string | number} v 传入的对比
     * @returns {boolean}
     */
    Version.prototype.lt = function (v) {
        return Version.compare(this.val, v) < 0;
    };
    /**
     * 当前app版本是否小于等于（<=）传入的版本号
     *
     * @param  {string | number} v 传入的对比
     * @returns {boolean}
     */
    Version.prototype.lte = function (v) {
        return Version.compare(this.val, v) <= 0;
    };
    /**
     * 当前app版本是否等于（=）传入的版本号
     *
     * @param  {string | number} v 传入的对比
     * @returns {boolean}
     */
    Version.prototype.eq = function (v) {
        return Version.compare(this.val, v) === 0;
    };
    /**
     * 当前app版本号
     */
    Version.prototype.toString = function () {
        return this.val;
    };
    return Version;
}());
var getVersion = function () {
    var ua = getUA();
    var execResult = /aliapp\([\w-]+\/([\d.]+)\)/i.exec(ua);
    if (!execResult) {
        return null;
    }
    var version = execResult && execResult[1] ? execResult[1] : '';
    return new Version(version);
};
/**
 * version 实例，只在阿里系 App 中才能获取到
 *
 * @example
 * ```js
 * version.toString() // 获取当前版本
 * version.gt('1.0.0') // 当前环境app版本大于1.0版本
 * version.lt('1.0.0') // 当前环境app版本小于1.0版本
 * version.gte('1.0.0') // 当前环境app版本大于等于1.0版本
 * ```
 */
var version = getVersion();

/**
 * 判端环境
 * 主要原理是根据ua和注入的参数可确定。
 * @example 使用案例：
 * import { env } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * // 淘系
 * env.isTb // 淘宝
 * env.isTbLive // 点淘App
 * env.isFm // 咸鱼
 * env.isAli1688 // 1688
 *
 * // 支付宝系
 * env.isAp
 *
 * // 菜鸟系
 * env.isCn // 菜鸟
 * env.isCnStation // 菜鸟驿站掌柜App
 * env.isMiniwebDingTalk // 钉钉小程序内嵌webview（如驿站盘古）
 *
 * // 小程序容器。包含阿里系、头条、微信、快手、百度小程序。
 * env.isMini
 *
 * // 小程序内嵌webview容器
 * env.isMiniweb
 *
 * // 纯浏览器
 * env.isBrowser
 *
 * @author 敬文
 */
var env = __assign(__assign(__assign({}, uniEnv), extendEnv), { // 扩展菜鸟
    /** app版本（根据ua获得） */
    version: version });

export { env };
